/**
 * Checks if the time span between two dates is longer than the timeBetween.
 *
 * @param one
 * @param two
 * @param timeBetween
 */
export function rangeCoversMoreThan(
    one: Date,
    two: Date,
    timeBetween: number
): boolean {
    return Math.abs(one.getTime() - two.getTime()) >= timeBetween;
}
